import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const apiFetchCarditBySendingPostNumbered = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getCarditBySendingPostNumbered',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchCarditBySendingPostNumbered;
